import apiClient from "../apiClient";
import { API_ROUTES } from "../../config/baseURL";

export const procesarCarguePacientesMasivo = async (payload) => {
  const res = await apiClient.post(API_ROUTES.processPatientMassUpload, payload);
  return res.data;
};

export const programarCarguePacientesMasivo = async (payload) => {
  const res = await apiClient.post(API_ROUTES.schedulePatientMassUpload, payload);
  return res.data;
};

export const obtenerCarguesPendientesPacientesMasivo = async () => {
  const res = await apiClient.get(API_ROUTES.getPendingPatientMassUploads);
  return res.data;
};

export const obtenerUltimoCargueEjecutadoPacientesMasivo = async () => {
  const res = await apiClient.get(API_ROUTES.getLastExecutedPatientMassUpload);
  return res.data;
};

export const obtenerHistoricoCarguePacientesMasivo = async () => {
  const res = await apiClient.get(API_ROUTES.getPatientMassUploadHistory);
  return res.data;
};

export const obtenerDetalleCarguePacientesMasivo = async (jobId) => {
  const res = await apiClient.get(API_ROUTES.getPatientMassUploadIssues(jobId));
  return res.data;
};

export const obtenerUltimoCarguePacientesMasivo = async () => {
  const res = await apiClient.get(API_ROUTES.getLastPatientMassUpload);
  return res.data;
};

export const obtenerErroresUltimoCarguePacientesMasivo = async () => {
  const res = await apiClient.get(API_ROUTES.getLastPatientMassUploadErrors);
  return res.data;
};
